module.exports = __webpack_public_path__ + "static/media/new4.819881b3.jpg";